import { SARDINE_ON_HOLD_CONSTANTS as types, ORDERS } from '@store/constants';
import { toGomsOrderData } from '@utils';

const initialState = {
  sardineOnHoldOrders: {
    orders: [],
    totalPages: 1,
    isLoading: false,
    isError: false,
    error: 0,
  }
};

const sardineOnHoldReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GETTING_SARDINE_ON_HOLD_ORDERS:
      return {
        ...state,
        sardineOnHoldOrders: {
          ...state.sardineOnHoldOrders,
          isLoading: true,
          isError: false,
          error: null
        }
      };

    case types.GET_SARDINE_ON_HOLD_ORDERS_SUCCESS:
      return {
        ...state,
        sardineOnHoldOrders: {
          ...state.sardineOnHoldOrders,
          orders: payload?.result?.map((order) => toGomsOrderData(order)) || [],
          totalPages: payload?.totalPage,
          isLoading: false,
          isError: false,
          error: null
        }
      };

    case types.GET_SARDINE_ON_HOLD_ORDERS_FAILURE:
      return {
        ...state,
        sardineOnHoldOrders: {
          ...state.sardineOnHoldOrders,
          orders: [],
          isLoading: false,
          isError: true,
          error: payload?.message || "Error: Something Went Wrong :("
        }
      };

    case types.CLEAR_SARDINE_ON_HOLD_ORDERS:
      return initialState;

    default:
      return state;
  }
};

export default sardineOnHoldReducer;
